import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {documentTypes} from "../../../../types/custom-types";

@Component({
    selector: 'app-document-form',
    templateUrl: './document-form.component.html',
    standalone: false
})
export class DocumentFormComponent implements OnInit{

  readonly documents: { code: string, description: string } [] = documentTypes()

  @Input('apiErrors') apiErrors : Map<string,string>
  @Input('eventForm') eventForm : FormGroup

  constructor() {
  }

  ngOnInit(): void {
  }

}
